import { Provider } from '@angular/core';
import { ContactRepository } from '../../domain/contact.repository';
import { ContactHttpRepository } from './contact-http.repository';

/**
 * Providers para Contact Repository
 *
 */
export function provideContactRepository(): Provider[] {
  return [
    {
      provide: ContactRepository,
      useClass: ContactHttpRepository
    }
  ];
}